import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductProductClassAsync,
  deleteProductProductClassAsync,
  editProductStyleAsync,
  editProductProductClassAsync,
  getProductStyleAsync,
  getProductProductClassAsync,
} from "../../../../store/services/productInfoServices";
const ProductClass = () => {
  const dispatch = useDispatch();
  const {
    getProductProductClassStatus,
    getProductProductClassError,
    getProductProductClassData,
    addProductProductClassStatus,
    addProductProductClassData,
    addProductProductClassError,

    editProductProductClassStatus,
    editProductProductClassError,
    editProductProductClassData,

    deleteProductProductClassData,
    deleteProductProductClassStatus,
    deleteProductProductClassError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductProductClassAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductProductClassData?.length
    ? getProductProductClassData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedProductClass, setSelectedProductClass] = useState();
  const [addProductClassMode, setAddProductClassMode] = useState(false);
  const [addProductClassData, setAddProductClassData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedProductClass", selectedProductClass);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductProductClassStatus === asyncStatus.SUCCEEDED) {
      setAddProductClassMode(false);
      setSaveDisabled(true);
      setAddProductClassData();
    }
  }, [, addProductProductClassStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductProductClassAsync(selectedProductClass?.product_class_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductProductClassStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedProductClass();
    }
  }, [, deleteProductProductClassStatus]);
  useEffect(() => {
    if (editProductProductClassStatus === asyncStatus.SUCCEEDED) {
      setSelectedProductClass();
      setEditMode(false);
    }
  }, [, editProductProductClassStatus]);
console.log("getProductProductClassData",getProductProductClassData,editProductProductClassData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ProductClass?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Product Class"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Product Class Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddProductClassMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addProductClassMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductClassMode || !selectedProductClass}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddProductClassMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductClassMode || !selectedProductClass}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductProductClassStatus === asyncStatus.LOADING ||
                  editProductProductClassStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addProductClassData) {
                    dispatch(addProductProductClassAsync(addProductClassData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedProductClass, ...editData };
                    delete a.id;
                    dispatch(editProductProductClassAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "product_class_id", headerName: "ID", flex: true },
                  {
                    field: "product_class_name",
                    headerName: "Product Class Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedProductClass(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductProductClassStatus === asyncStatus.IDLE ||
                  getProductProductClassStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addProductClassMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Product Class:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddProductClassData({
                            ...addProductClassData,
                            product_class_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddProductClassData({
                            ...addProductClassData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedProductClass ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedProductClass?.product_class_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ProductClass:",
                    comp: (
                      <InputComp
                        key={selectedProductClass?.product_class_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            product_class_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedProductClass?.product_class_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedProductClass?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedProductClass?.is_active ? true : false
                        }
                        checked={selectedProductClass?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any product class</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductProductClassError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductProductClassError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductProductClassError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductProductClassError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedProductClass(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedProductClass(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ProductClass;
